export default "__VITE_ASSET__BOE_HC14__"